import { Injectable } from '@angular/core';
import { Endpoints } from 'src/environments/endpoints';
import { ConsumeService } from './consume.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private consume: ConsumeService) { }


  // getOrigins(){
  //   return this.consume.httpGet(`${Endpoints.catalogsV2.base}/youmetusat/1`);
  // }

  deleteUserById(idUser: string){
    return this.consume.httpDelete(`${Endpoints.clientes.base}/delete-client/${idUser}`);
  }

  updateUserAttributes( body: any, idUser: string ){
    return this.consume.httpPut(`${Endpoints.clientes.base}/add-attributes-client/${idUser}`, body);
  }

}
